import { twMerge } from "tailwind-merge";

export function NormalText({
  children,
  elementType,
  className,
  id,
}: {
  children: React.ReactNode;
  elementType: "p" | "li" | "span";
  className?: string;
  id?: string;
}) {
  const Element = elementType;

  return (
    <Element
      id={id}
      className={twMerge(
        "text-sm font-normal leading-6 text-gray-900",
        className
      )}
    >
      {children}
    </Element>
  );
}
